export default "__VITE_ASSET__dfebc258__"